
import { Component, Vue, Prop } from "vue-property-decorator";
import { Answer } from "@/lib/model/exam/result"; //候选人答案内容
import { Question, ChoiceQuestion } from "@/lib/model/question/question";
import { getDimensionColor } from "@/lib/dimension/dimension-color";
import SvgImg from "@/components/videoPaly/index.vue";
import ProgressLine from "./ProgressLine.vue";
import CandidateAnswerSection from "@/views/paper/components/candidate-answer-section.vue";
import ColorTest from "@/views/paper/components/eye-color.vue";

import TooltipMaterials from "@/components/tooltip/index.vue";

import AudioStyle from "@/components/videoPaly/audioStyle.vue";

@Component({
  components: {
    SvgImg,
    ProgressLine,
    CandidateAnswerSection,
    ColorTest,
    TooltipMaterials,
    AudioStyle
  }
})
export default class QuestionContent extends Vue {
  @Prop({ type: Question, required: true }) question!: Question; //题目
  @Prop({ type: Boolean, required: true }) canSelectFlag!: boolean; //是否可选
  @Prop({ type: Boolean, required: false, default: false }) checked!: boolean; //是否选中
  @Prop({ type: Boolean, required: false, default: false }) mark!: boolean; //是否阅卷页面、
  @Prop({ type: Answer, default: new Answer() }) answer!: Answer; //候选人回答
  @Prop({ type: Number, default: "" }) qIndex!: number;
  @Prop({ type: Boolean, default: true }) showChange!: boolean; //是否展示题干变量
  @Prop({ type: Boolean, default: false }) isFSK!: boolean; //富士康
  @Prop({ type: Boolean, default: false }) marked!: boolean; //是否阅过卷  用来判是否可修改试卷
  @Prop({ type: Boolean, default: false }) isNewAi!: boolean; //是否Aibuilder阅卷
  @Prop() all!: any; //
  asrActive = false;

  // checkedFlag = false;
  noAnswer = "未作答";
  lastDesc = ""; //题干变量最后一节
  audioElement: any = null;
  activeIndex = -1;
  isPlay = false;
  presentT = 0;
  totalT = 0;
  persentLoad = 0;
  videoCurrentTime = "00:00:00";
  videoTotalTime = "00:00:00";
  filterHtmlTag(e: string) {
    const startPi = e.indexOf("<p>");
    const endPi = e.indexOf("</p>");
    return e.substring(startPi + 3, endPi);
  }
  mounted() {
    // this.checkedFlag = this.checked;
    this.listenVideo();
    const videoObj = this.$refs.video as HTMLAudioElement;
    if (videoObj) {
      videoObj.addEventListener("canplay", this.getTotalTime);
    }
  }
  beforeDestory() {
    const videoObj = this.$refs.video as HTMLAudioElement;
    videoObj.removeEventListener("canplay", this.getTotalTime);
  }
  getBlankCandidateAnswer() {
    let res = ``;
    const list = this.answer.blanks;
    const isRight = this.answer.blanksIsRight;
    list.forEach((d: any, i: number) => {
      res += `${i + 1}.（${d}）【${isRight[i] ? "正确" : "错误"}】；`;
    });
    return res;
  }
  getBlankAnswer() {
    const list = this.question.blankQuestionConfig.answerList;
    let res = ``;
    list.forEach((d: any, i: number) => {
      res += `${i + 1}.（${d.words}）；`;
    });
    return res;
  }
  get eye() {
    if (this.getQuestionType()[0] === "色盲检测") {
      return this.all.errorInfoList.find((d: any) => {
        return d.task === "eyeColor";
      });
    } else {
      return [];
    }
  }
  get eyeResult() {
    const r = this.eye.result;
    return r === 0
      ? "未检测"
      : r === 1
      ? this.eye.resMessage || "辨色检测异常"
      : r === 2
      ? "通过"
      : "";
  }

  get getScoreRule() {
    const s = this.question.scoreRuleStatus;
    return s === 10
      ? "AI"
      : s === 20
      ? "自动"
      : s === 30
      ? "人工"
      : "无评分规则";
  }

  getTotalTime() {
    const videoObj = this.$refs.video as HTMLAudioElement;
    if (videoObj) {
      this.totalT = videoObj.duration;
      this.videoTotalTime = this.formatSeconds(this.totalT * 1000);
    }
  }
  //根据类型 获取对应值
  getQuestionType(): string[] {
    switch (this.question.type) {
      case 1:
        return ["单选题", ""];
      case 2:
        return ["多选题", ""];
      case 5:
        return ["填空题", ""];
      case 6:
        return ["视频问答题", ""];
      case 7:
        return ["测评单选题", ""];
      case 8:
        return ["音频题", ""];
      case 101:
        return ["通勤时间题", ""];
      case 102:
        return ["色盲检测", ""];
      default:
        return ["其他类型", ""];
    }
  }
  changeCurrentTime(data: any) {
    (this.$refs.video as HTMLAudioElement).currentTime = data; // 点击进度条设置视频当前播放点
  }
  changeCurrentWord(data: any) {
    this.videoCurrentTime = this.formatSeconds(data * 1000); // 当前播放时间显示文字
  }
  videoProgress() {
    const audioElement = this.$refs.video as HTMLAudioElement;
    if (audioElement) {
      const bf = audioElement.buffered;
      const time = audioElement.currentTime;
      if (bf.length != 0) {
        let range = 0;
        while (!(bf.start(range) <= time && time <= bf.end(range))) {
          range += 1;
        }

        const loadEndPercentage = (bf.end(range) / audioElement.duration) * 100; // 结束加载的百分比
        this.persentLoad = loadEndPercentage;
        console.log(loadEndPercentage);
      }
    }
  }
  playAudio() {
    const audioElement = this.$refs.video as HTMLAudioElement;
    if (!this.isPlay) {
      audioElement.play();
    } else {
      audioElement.pause();
    }
    this.isPlay = !this.isPlay;
  }
  playAudioDesc() {
    // 先停止其他音频
    const audioElements = document.querySelectorAll("audio");
    audioElements.forEach((audioElement: any) => {
      // 暂停其他audio用于后面判断当前audio的播放状态
      if (audioElement.id !== "audioDesc-" + this.question.questionId) {
        // 切换audio需要从头播放时放开下面
        // audioElement.setAttribute('src', audioElement.src)
        audioElement.pause();
      }
    });
    // 播放音频材料
    if (!this.audioElement) {
      this.audioElement = document.createElement("audio");
      document.body.appendChild(this.audioElement);
    }
    if (!this.audioElement.paused) {
      this.audioElement.pause();
    } else {
      // 需求暂停后不要从头播放，需要时去掉判断条件
      if (!this.audioElement.id && !this.audioElement.src) {
        this.audioElement.setAttribute(
          "id",
          "audioDesc-" + this.question.questionId
        );
        this.audioElement.setAttribute("src", this.question.audioDescUrl);
      }
      this.audioElement.play();
    }
  }
  //填空题规则
  getRule() {
    let res = ``;
    res +=
      this.question.blankQuestionConfig.strictOrder == 1
        ? "完全一致"
        : "顺序可不一致";
    res += ` | `;
    res +=
      this.question.blankQuestionConfig.scoreType == 1
        ? "出错得0分，全对得满分"
        : this.question.blankQuestionConfig.scoreType == 2
        ? "按答对比例给分"
        : "各空分数独立设置";
    res += ` | `;
    res +=
      this.question.blankQuestionConfig.ignoreBlank == 1
        ? "忽略答案中的空格"
        : "不忽略答案中的空格";
    return res;
  }
  //asr时间格式化
  formatSeconds(mss: number) {
    const hours =
      Math.floor((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) < 10
        ? "0" + Math.floor((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        : Math.floor((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

    const minutes =
      Math.floor((mss % (1000 * 60 * 60)) / (1000 * 60)) < 10
        ? "0" + Math.floor((mss % (1000 * 60 * 60)) / (1000 * 60))
        : Math.floor((mss % (1000 * 60 * 60)) / (1000 * 60));

    const seconds =
      (mss % (1000 * 60)) / 1000 < 10
        ? "0" + Math.floor((mss % (1000 * 60)) / 1000)
        : Math.floor((mss % (1000 * 60)) / 1000);

    return `${hours}:${minutes}:${seconds}`;
  }
  //选择播放语句
  selectVideoTime(st: any, id: any) {
    // @ts-ignore
    const player: HTMLMediaElement = document.getElementById("player" + id);
    player.currentTime = Math.floor(st / 1000);
    player.play();
  }
  //拼接通勤参考答案
  getLocationAnswer(q: Question) {
    const option1 = q.locationQuestionConfig.choiceQuestionList;
    const option2 = q.locationQuestionConfig.timeToScoreRules;
    let t =
      q.locationQuestionConfig.useDrivingTime === 1
        ? `驾车时：`
        : `乘坐公共交通时：`;
    option2.forEach((d: any, i: number) => {
      if (i === option2.length - 1) {
        t += `${d.timeRange[0]}分钟以上（${d.score}分）；<br/>`;
        return;
      }
      t += `${d.timeRange[0]}-${d.timeRange[1]}分钟（${d.score}分）；`;
    });
    option1.forEach((d: any, i: number) => {
      t += `<span class="p-inline">${d.desc}</span>（${d.score}分）<br/>`;
    });

    return t;
  }
  //拼接通勤时间 候选人回答
  getLocationText() {
    const t = this.answer?.locationQuestionAnswer;
    //未作答
    if (!t) return;
    //正常作答
    if (this.answer?.keys?.[0]) {
      return `我住在<b>${
        t.locationName
      }</b>附近，<br/>经系统计算从该地点到上班地点：<br/>驾车距离<b>${(
        t.distanceDriving / 1000
      ).toFixed(1)}公里</b>，用时<b>${
        t.timeDriving
      }分钟</b>，<br/>乘坐公共交通距离<b>${(t.distanceTransit / 1000).toFixed(
        1
      )}公里</b>，用时<b>${t.timeTransit}分钟</b>。`;
    } else {
      //定位故障
      if (t.locationName) {
        return `我住在${t.locationName}附近`;
      }
      //暂无居所
      if (t.choiceQuestionAnswer) {
        const res: ChoiceQuestion[] = this.question.locationQuestionConfig.choiceQuestionList.filter(
          (d: any) => {
            return d.key === t.choiceQuestionAnswer;
          }
        );
        return res?.[0]?.desc;
      }
    }
  }
  //选中card复选框
  checkCard() {
    // this.checked = !this.checked;
  }
  //题目tag选中
  changeTag(item: any) {
    item.hrResult = item.hrResult === 0 ? 1 : 0;
    //插入文本
    if (item.hrResult === 1) {
      this.$emit("resultAddText", item.tagName);
    }
  }
  //监听video播放
  listenVideo() {
    const v: any = this.$refs["PCvideo-" + this.qIndex];
    if (!v) return;
    v.addEventListener("play", (e: any) => {
      console.log(e);
      this.asrActive = true;
      this.$emit("pauseOther", this.qIndex, this.question.questionId);
    });
  }
  //自动暂停
  pauseMe(qIndex: number) {
    if (qIndex === this.qIndex) return;
    const v: any = this.$refs["PCvideo-" + this.qIndex];
    if (!v) return;
    v?.pause();
    this.asrActive = false;
  }
  //正确选项
  getRightAnswer(list: any) {
    return list.find((d: any) => {
      return d.isRight === 1;
    }).key;
  }
  //题干变量处理
  filterQuestion(q: Question) {
    const result: any[] = [];
    let indexStart = 3;
    q.descTemplateConfig.forEach((d: any, i: number) => {
      const end = q.desc.indexOf(d.originStr);
      // if(end === -1) return
      const ob: any = {};
      ob.text = q.desc.slice(indexStart, end);
      ob.str = d.originStr;
      let st = `<span style="
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #111111;
      line-height: 24px;"><span style="color:#525FFFFF;font-weight: 600;font-family:   PingFang SC">#${d.originStr}# </span>是一个变量<br>候选人看到的内容取决于其在${d.keyType}填写的<span style="font-family:   PingFang SC;font-weight: 600;"> ${d.paramName}</span></span>
      <div style="width: 100%;
      padding:1px 0;
      margin-top:12px;
      background: #F4F7FC;
      border-radius: 8px;">`;
      d.replaceStrList.forEach((m: any, n: number) => {
        st += `<div style="
                display:flex;
                align-items:baseline;
                margin:8px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #111111;
                line-height: 24px;">
                <span style="display: inline-block;
                 flex-shrink:0;
                 flex-grow:0;
                 position:relative;
                 top:-2px;
                 width: 4px;
                 height: 4px;
                 border-radius: 6px;
                 border: 1px solid #111111;
                 margin: 0 6px 0 0;"></span><span><span style="font-family:   PingFang SC;font-weight: 600;"> ${d.paramName} </span>为<span style="font-family:   PingFang SC;font-weight: 600;"> ${m.key} </span>时，此处展示为<span style="font-family:   PingFang SC;font-weight: 600;"> ${m.value}</span>;</span></div>`;
      });
      st += `<div style="
                margin:8px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #111111;
                line-height: 24px;">
                <span style="display: inline-block;
                 width: 4px;
                 height: 4px;
                 border-radius: 6px;
                 border: 1px solid #111111;
                 margin: 0 6px 2px 0;"></span>除以上情况外，此处展示为<span style="font-family:   PingFang SC;font-weight: 600;"> ${d.defaultStr}。</span></div></div>`;
      ob.options = st;
      result.push(ob);
      indexStart = end + d.originStr.length;
    });
    this.lastDesc = q.desc.slice(indexStart, -4);
    return result;
  }

  //维度标签颜色处理
  getDimColors(name: string) {
    return getDimensionColor(name);
  }
  timeupdateOld({ target }: Event, answer: Answer) {
    // const player: HTMLMediaElement = e.target;
    try {
      this.presentT = (target as HTMLAudioElement).currentTime; // 获取当前播放时长
      this.videoCurrentTime = this.formatSeconds(this.presentT * 1000);
      answer.asrList.forEach((el, index: number) => {
        if (el.ed > (target as HTMLMediaElement).currentTime * 1000) {
          this.activeIndex = index;
          throw new Error("I");
        }
      });
    } catch (error) {
      error;
    }
  }

  //追问ASR
  playTime = 0; // 记录答案播放进度
  lastPlayVideoIndex = -1; // 最后播放的视频序号
  questionIndexAppendIndex = [-1, -1]; //正在播放的回答视频 [题号，追问index]

  timeupdate({ target }: Event, answerIndex: number) {
    this.playTime = (target as HTMLMediaElement).currentTime * 1000;
    this.lastPlayVideoIndex = answerIndex;
  }

  onClickAsrItem(data: {
    answerIndex: number;
    appendIndex: number;
    time: number;
  }) {
    const refName = "PCvideo-" + data.answerIndex;
    this.questionIndexAppendIndex = [data.answerIndex, data.appendIndex];
    try {
      // 找到this.$refs中所有PCvideo-开头的元素，除要播放的以外的全部停止
      // for (const key in this.$refs) {
      //   const element = this.$refs[key];
      //   if (key.indexOf("PCvideo-") === 0 && key !== refName) {
      //     element[0].pause();
      //   }
      // }
      //当前题目播放器
      const videoPalyer = this.$refs[refName] as HTMLVideoElement;
      if (!videoPalyer) return;
      //播放地址 默认主回答
      let videoUrl = this.all.answerList[data.answerIndex].aliyunVideoUrl;
      if (data.appendIndex > -1) {
        //播放地址 切换追问
        videoUrl = this.all.answerList[data.answerIndex].videoAppendAnswerList[
          data.appendIndex
        ].videoUrl;
      }
      videoPalyer.src = videoUrl;
      videoPalyer.poster =
        videoUrl + "?x-oss-process=video/snapshot,t_2000,f_jpg,ar_auto";
      videoPalyer.currentTime = data.time / 1000 + 0.01; // 这个地方+0.01防止上一句话闪一下
      videoPalyer.play();
    } catch (e) {
      console.log(e);
    }
  }

  // 自动播放下一个追问
  onEnded(questionIndex: number) {
    if (this.all.answerList[questionIndex].videoAppendAnswerList.length === 0)
      return;
    if (
      this.questionIndexAppendIndex[1] <
      this.all.answerList[questionIndex].videoAppendAnswerList.length - 1
    ) {
      this.onClickAsrItem({
        answerIndex: questionIndex,
        appendIndex: this.questionIndexAppendIndex[1] + 1,
        time: 0
      });
    }
  }
  //前一个追问
  preAppend(questionIndex: number) {
    this.questionIndexAppendIndex[0] = questionIndex;
    if (this.questionIndexAppendIndex[1] > -1) {
      this.onClickAsrItem({
        answerIndex: this.questionIndexAppendIndex[0],
        appendIndex: this.questionIndexAppendIndex[1] - 1,
        time: 0
      });
    }
  }
  //下一个追问
  nextAppend(questionIndex: number) {
    this.questionIndexAppendIndex[0] = questionIndex;
    if (
      this.questionIndexAppendIndex[1] <
      this.all.answerList[this.questionIndexAppendIndex[0]]
        .videoAppendAnswerList.length -
        1
    ) {
      this.onClickAsrItem({
        answerIndex: this.questionIndexAppendIndex[0],
        appendIndex: this.questionIndexAppendIndex[1] + 1,
        time: 0
      });
    }
  }
}
